export enum TableSortOrderType {
  Ascending = 1,
  Descending = -1,
}
